import { combineReducers } from 'redux';
import { SidebarReducer } from './sidebar/reducer';
import { SocketsReducer } from './sockets/reducer';
import { VideoReducer } from './video/reducer';
import { UsersReducer } from './users/reducer';
import { InteractiveReducer } from './interactive/reducer';
import { FinalTestReducer } from './finalTest/reducer';
import { CallToActionReducer } from './callToAction/reducer';
import { PrivateChatReducer } from './privateChat/reducer';
import { TicketReducer } from './ticket/reducer';
import { CerteficateReducer } from './certeficate/reducer';
import { TechnicalTextsReducer } from './technicalTexts/reducer';

const rootReducer = combineReducers({
  Sidebar: SidebarReducer,
  Video: VideoReducer,
  Sockets: SocketsReducer,
  Users: UsersReducer,
  Interactive: InteractiveReducer,
  FinalTest: FinalTestReducer,
  CallToAction: CallToActionReducer,
  PrivateChat: PrivateChatReducer,
  Ticket: TicketReducer,
  Certeficate: CerteficateReducer,
  TechnicalTexts: TechnicalTextsReducer,
});

export default rootReducer;
